module.exports = __webpack_public_path__ + "img/empty.e77cf292.jpg";